/* ==========================================================================
   Wellness Buddy's Dawn Theme - Interactive Scripts (wb-custom.js)
   All selectors use wb- prefixed classes for Dawn compatibility.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  wbInitAgeGate();
  wbInitCartDrawer();
  wbInitFaqAccordion();
  wbInitPdpAccordions();
  wbInitProductGallery();
  wbInitStickyBuyBar();
  wbInitHeroSlider();
  wbInitTestimonialCarousel();
  wbInitReviewFormToggle();
  wbInitScrollReveal();
});

/* ============================================================
   1. Age Gate Popup Control
   ============================================================ */
function wbInitAgeGate() {
  const ageGate = document.getElementById('WbAgeGate');
  if (!ageGate) return;

  if (localStorage.getItem('wb_age_verified') === 'true') {
    ageGate.classList.add('wb-verified');
    document.body.style.overflow = '';
  } else {
    ageGate.classList.remove('wb-verified');
    document.body.style.overflow = 'hidden';
  }

  const btnYes = document.getElementById('WbAgeGateYes');
  const btnNo = document.getElementById('WbAgeGateNo');

  if (btnYes) {
    btnYes.addEventListener('click', () => {
      localStorage.setItem('wb_age_verified', 'true');
      ageGate.classList.add('wb-verified');
      document.body.style.overflow = '';
    });
  }

  if (btnNo) {
    btnNo.addEventListener('click', () => {
      window.location.href = 'https://www.google.com';
    });
  }
}

/* ============================================================
   2. Cart Drawer & AJAX Simulator
   ============================================================ */
let wbCartState = {
  items: [],
  subtotal: 0,
  shippingThreshold: 1500
};

function wbInitCartDrawer() {
  const drawer = document.getElementById('WbCartDrawer');
  const overlay = document.getElementById('WbCartDrawerOverlay');
  const closeBtn = document.getElementById('WbCartDrawerClose');
  const openBtns = document.querySelectorAll('.wb-js-open-cart');
  const addToCartForms = document.querySelectorAll('.wb-js-add-to-cart-form');
  const stickyCartBtn = document.getElementById('WbStickyAddToCart');

  const openDrawer = () => {
    if (!drawer) return;
    wbUpdateCartDOM();
    drawer.classList.add('wb-active');
    if (overlay) overlay.classList.add('wb-active');
    document.body.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('wb-active');
    if (overlay) overlay.classList.remove('wb-active');
    document.body.style.overflow = '';
  };

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  openBtns.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  }));

  // Quantity controls
  const qtyWrappers = document.querySelectorAll('.wb-qty-control');
  qtyWrappers.forEach(wrap => {
    const btnMinus = wrap.querySelector('.wb-qty-minus');
    const btnPlus = wrap.querySelector('.wb-qty-plus');
    const valInput = wrap.querySelector('.wb-qty-val');

    if (btnMinus && btnPlus && valInput) {
      btnMinus.addEventListener('click', () => {
        let val = parseInt(valInput.textContent || valInput.value || '1');
        if (val > 1) {
          val--;
          if (valInput.textContent !== undefined) valInput.textContent = val;
          if (valInput.value !== undefined) valInput.value = val;
        }
      });

      btnPlus.addEventListener('click', () => {
        let val = parseInt(valInput.textContent || valInput.value || '1');
        val++;
        if (valInput.textContent !== undefined) valInput.textContent = val;
        if (valInput.value !== undefined) valInput.value = val;
      });
    }
  });

  // Add to Cart form submissions
  addToCartForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const qtyElement = form.querySelector('.wb-qty-val');
      let qty = 1;
      if (qtyElement) {
        qty = parseInt(qtyElement.textContent || qtyElement.value || '1');
      }

      const pId = parseInt(form.getAttribute('data-product-id')) || 12345;
      const pTitle = form.getAttribute('data-product-title') || 'Wellness Product';
      const pPrice = parseInt(form.getAttribute('data-product-price')) || 1199;
      const pImage = form.getAttribute('data-product-image') || '';

      wbAddItemToCart({ id: pId, title: pTitle, price: pPrice, image: pImage }, qty);
      openDrawer();
    });
  });

  if (stickyCartBtn) {
    stickyCartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      wbAddItemToCart({ id: 12345, title: 'Wellness Product', price: 1199, image: '' }, 1);
      openDrawer();
    });
  }
}

function wbAddItemToCart(product, qty) {
  const existingIndex = wbCartState.items.findIndex(item => item.id === product.id);
  if (existingIndex > -1) {
    wbCartState.items[existingIndex].qty += qty;
  } else {
    wbCartState.items.push({ ...product, qty: qty });
  }
  wbCalculateCartSubtotal();
}

function wbUpdateCartDOM() {
  const cartItemsContainer = document.getElementById('WbCartItems');
  const subtotalLabel = document.getElementById('WbCartSubtotalAmount');
  const cartBadges = document.querySelectorAll('.wb-cart-count-badge');
  const shippingFill = document.getElementById('WbShippingFill');
  const shippingTitle = document.getElementById('WbShippingTitle');

  if (!cartItemsContainer) return;

  cartItemsContainer.innerHTML = '';

  if (wbCartState.items.length === 0) {
    cartItemsContainer.innerHTML = '<p style="text-align:center;color:#9a9a9a;padding:40px 0;">Your cart is empty.</p>';
    if (subtotalLabel) subtotalLabel.textContent = '₹0';
    cartBadges.forEach(b => b.style.display = 'none');
    if (shippingFill) shippingFill.style.width = '0%';
    if (shippingTitle) shippingTitle.innerHTML = 'Add <strong>₹' + wbCartState.shippingThreshold + '</strong> for <strong>FREE SHIPPING</strong>';
    return;
  }

  wbCartState.items.forEach((item, index) => {
    const itemHtml = `
      <div class="wb-cart-item">
        <div class="wb-cart-item-img">
          <img src="${item.image}" alt="${item.title}" style="width:100%;height:100%;object-fit:cover;">
        </div>
        <div class="wb-cart-item-info">
          <div>
            <h4 class="wb-cart-item-title">${item.title}</h4>
            <div class="wb-cart-item-price">₹${item.price.toLocaleString('en-IN')}</div>
          </div>
          <div class="wb-cart-item-qty">
            <div class="wb-qty-control" data-item-index="${index}">
              <button type="button" class="wb-qty-control-btn wb-qty-minus" onclick="wbChangeQty(${index}, -1)">-</button>
              <span class="wb-qty-control-val">${item.qty}</span>
              <button type="button" class="wb-qty-control-btn wb-qty-plus" onclick="wbChangeQty(${index}, 1)">+</button>
            </div>
            <button type="button" class="wb-cart-item-remove" onclick="wbRemoveCartItem(${index})">Remove</button>
          </div>
        </div>
      </div>
    `;
    cartItemsContainer.insertAdjacentHTML('beforeend', itemHtml);
  });

  const totalQty = wbCartState.items.reduce((acc, item) => acc + item.qty, 0);
  cartBadges.forEach(b => {
    b.textContent = totalQty;
    b.style.display = 'block';
  });

  if (subtotalLabel) subtotalLabel.textContent = '₹' + wbCartState.subtotal.toLocaleString('en-IN');

  if (shippingFill && shippingTitle) {
    const percent = Math.min((wbCartState.subtotal / wbCartState.shippingThreshold) * 100, 100);
    shippingFill.style.width = percent + '%';

    if (wbCartState.subtotal >= wbCartState.shippingThreshold) {
      shippingTitle.innerHTML = '🎉 You have unlocked <strong>FREE SHIPPING!</strong>';
    } else {
      const remaining = wbCartState.shippingThreshold - wbCartState.subtotal;
      shippingTitle.innerHTML = 'Add <strong>₹' + remaining.toLocaleString('en-IN') + '</strong> more for <strong>FREE SHIPPING</strong>';
    }
  }
}

window.wbChangeQty = function(index, delta) {
  if (wbCartState.items[index]) {
    wbCartState.items[index].qty += delta;
    if (wbCartState.items[index].qty <= 0) {
      wbCartState.items.splice(index, 1);
    }
    wbCalculateCartSubtotal();
    wbUpdateCartDOM();
  }
};

window.wbRemoveCartItem = function(index) {
  if (wbCartState.items[index]) {
    wbCartState.items.splice(index, 1);
    wbCalculateCartSubtotal();
    wbUpdateCartDOM();
  }
};

function wbCalculateCartSubtotal() {
  wbCartState.subtotal = wbCartState.items.reduce((acc, item) => acc + (item.price * item.qty), 0);
}

/* ============================================================
   3. FAQ Accordion Control
   ============================================================ */
function wbInitFaqAccordion() {
  const faqQuestions = document.querySelectorAll('.wb-faq-question');

  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const faqItem = question.parentElement;
      const isActive = faqItem.classList.contains('wb-active');

      // Close all other items
      document.querySelectorAll('.wb-faq-item').forEach(item => {
        item.classList.remove('wb-active');
      });

      // Toggle current item
      if (!isActive) {
        faqItem.classList.add('wb-active');
      }
    });
  });
}

/* ============================================================
   4. PDP Accordions Control
   ============================================================ */
function wbInitPdpAccordions() {
  const headers = document.querySelectorAll('.wb-pdp-accordion-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      const isActive = item.classList.contains('wb-active');

      // Close other accordions in the same group
      const parentGroup = header.closest('.wb-pdp-accordions-group');
      if (parentGroup) {
        parentGroup.querySelectorAll('.wb-pdp-accordion-item').forEach(el => {
          el.classList.remove('wb-active');
        });
      }

      // Toggle clicked item
      if (!isActive) {
        item.classList.add('wb-active');
      }
    });
  });
}

/* ============================================================
   5. Product Gallery Thumbnail Toggle
   ============================================================ */
function wbInitProductGallery() {
  const thumbnails = document.querySelectorAll('.wb-pdp-thumbnail');
  const mainImage = document.getElementById('WbPdpMainImage');

  if (!mainImage) return;

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('wb-active'));
      thumb.classList.add('wb-active');

      const newSrc = thumb.getAttribute('data-image-src');
      mainImage.style.opacity = '0';
      mainImage.style.transition = 'opacity 0.3s ease';

      setTimeout(() => {
        mainImage.setAttribute('src', newSrc);
        mainImage.style.opacity = '1';
      }, 200);
    });
  });
}

/* ============================================================
   6. Sticky Bottom Buy Bar Scroll Trigger (Mobile)
   ============================================================ */
function wbInitStickyBuyBar() {
  const stickyBar = document.getElementById('WbStickyBuyBar');
  const pdpBuyBox = document.getElementById('WbPdpBuyBox');

  if (!stickyBar) return;

  window.addEventListener('scroll', () => {
    if (window.innerWidth <= 768) {
      let triggerOffset = 500;
      if (pdpBuyBox) {
        triggerOffset = pdpBuyBox.offsetTop + pdpBuyBox.offsetHeight;
      }

      if (window.scrollY > triggerOffset) {
        stickyBar.classList.add('wb-visible');
      } else {
        stickyBar.classList.remove('wb-visible');
      }
    } else {
      stickyBar.classList.remove('wb-visible');
    }
  });
}

/* ============================================================
   7. Hero Slider with Autoplay & Dot Navigation
   ============================================================ */
function wbInitHeroSlider() {
  const slider = document.querySelector('.wb-hero-slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.wb-hero-slide');
  const dotsContainer = slider.querySelector('.wb-hero-dots');
  let currentIndex = 0;
  let autoplayTimer = null;
  const autoplayDelay = 5000;

  if (slides.length <= 1) return;

  // Create dots if container exists
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.classList.add('wb-hero-dot');
      dot.setAttribute('type', 'button');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      if (i === 0) dot.classList.add('wb-active');
      dot.addEventListener('click', () => {
        goToSlide(i);
        resetAutoplay();
      });
      dotsContainer.appendChild(dot);
    });
  }

  const dots = dotsContainer ? dotsContainer.querySelectorAll('.wb-hero-dot') : [];

  function goToSlide(index) {
    slides[currentIndex].classList.remove('wb-active');
    if (dots[currentIndex]) dots[currentIndex].classList.remove('wb-active');

    currentIndex = index;

    slides[currentIndex].classList.add('wb-active');
    if (dots[currentIndex]) dots[currentIndex].classList.add('wb-active');
  }

  function nextSlide() {
    const nextIndex = (currentIndex + 1) % slides.length;
    goToSlide(nextIndex);
  }

  function startAutoplay() {
    autoplayTimer = setInterval(nextSlide, autoplayDelay);
  }

  function resetAutoplay() {
    clearInterval(autoplayTimer);
    startAutoplay();
  }

  // Arrow navigation
  const prevBtn = slider.querySelector('.wb-hero-prev');
  const nextBtn = slider.querySelector('.wb-hero-next');

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      goToSlide(prevIndex);
      resetAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoplay();
    });
  }

  // Pause on hover
  slider.addEventListener('mouseenter', () => clearInterval(autoplayTimer));
  slider.addEventListener('mouseleave', () => startAutoplay());

  startAutoplay();
}

/* ============================================================
   8. Testimonial Carousel with Autoplay
   ============================================================ */
function wbInitTestimonialCarousel() {
  const carousel = document.querySelector('.wb-testimonial-carousel');
  if (!carousel) return;

  const track = carousel.querySelector('.wb-testimonial-track');
  const cards = carousel.querySelectorAll('.wb-testimonial-card');
  const dotsContainer = carousel.querySelector('.wb-testimonial-dots');
  let currentIndex = 0;
  let autoplayTimer = null;
  const autoplayDelay = 4000;

  if (cards.length <= 1) return;

  // Determine visible cards based on viewport
  function getVisibleCount() {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 1024) return 2;
    return 3;
  }

  function getMaxIndex() {
    return Math.max(0, cards.length - getVisibleCount());
  }

  // Create dots
  if (dotsContainer) {
    function buildDots() {
      dotsContainer.innerHTML = '';
      const maxIdx = getMaxIndex();
      for (let i = 0; i <= maxIdx; i++) {
        const dot = document.createElement('button');
        dot.classList.add('wb-testimonial-dot');
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        if (i === currentIndex) dot.classList.add('wb-active');
        dot.addEventListener('click', () => {
          goToSlide(i);
          resetAutoplay();
        });
        dotsContainer.appendChild(dot);
      }
    }
    buildDots();
    window.addEventListener('resize', () => {
      if (currentIndex > getMaxIndex()) currentIndex = getMaxIndex();
      buildDots();
      updatePosition();
    });
  }

  function updatePosition() {
    if (!track) return;
    const cardWidth = cards[0].offsetWidth;
    const gap = parseInt(getComputedStyle(track).gap) || 24;
    const offset = currentIndex * (cardWidth + gap);
    track.style.transform = 'translateX(-' + offset + 'px)';
    track.style.transition = 'transform 0.5s ease';

    // Update dots
    if (dotsContainer) {
      const allDots = dotsContainer.querySelectorAll('.wb-testimonial-dot');
      allDots.forEach((d, i) => {
        d.classList.toggle('wb-active', i === currentIndex);
      });
    }
  }

  function goToSlide(index) {
    currentIndex = Math.min(index, getMaxIndex());
    updatePosition();
  }

  function nextSlide() {
    if (currentIndex >= getMaxIndex()) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
    updatePosition();
  }

  function startAutoplay() {
    autoplayTimer = setInterval(nextSlide, autoplayDelay);
  }

  function resetAutoplay() {
    clearInterval(autoplayTimer);
    startAutoplay();
  }

  // Arrow navigation
  const prevBtn = carousel.querySelector('.wb-testimonial-prev');
  const nextBtn = carousel.querySelector('.wb-testimonial-next');

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const prevIndex = currentIndex > 0 ? currentIndex - 1 : getMaxIndex();
      goToSlide(prevIndex);
      resetAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoplay();
    });
  }

  // Pause on hover
  carousel.addEventListener('mouseenter', () => clearInterval(autoplayTimer));
  carousel.addEventListener('mouseleave', () => startAutoplay());

  startAutoplay();
}

/* ============================================================
   9. Review Form Show/Hide
   ============================================================ */
function wbInitReviewFormToggle() {
  const toggleBtn = document.getElementById('WbToggleReviewFormBtn');
  const formContainer = document.getElementById('WbReviewFormContainer');

  if (!toggleBtn || !formContainer) return;

  toggleBtn.addEventListener('click', () => {
    if (formContainer.style.display === 'none' || formContainer.style.display === '') {
      formContainer.style.display = 'block';
      toggleBtn.textContent = 'Cancel';
    } else {
      formContainer.style.display = 'none';
      toggleBtn.textContent = 'Write a Review';
    }
  });
}

/* ============================================================
   10. Scroll Reveal Animations (IntersectionObserver)
   ============================================================ */
function wbInitScrollReveal() {
  const revealElements = document.querySelectorAll('.wb-scroll-reveal');

  if (!revealElements.length) return;

  // Check for reduced motion preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealElements.forEach(el => {
      el.classList.add('wb-revealed');
    });
    return;
  }

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -60px 0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Apply stagger delay if specified
        const delay = entry.target.getAttribute('data-wb-delay') || '0';
        entry.target.style.transitionDelay = delay + 'ms';
        entry.target.classList.add('wb-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  revealElements.forEach(el => observer.observe(el));
}
